import jwtDecode from 'jwt-decode';
import axios from './axios';

// ----------------------------------------------------------------------

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  try {
    const decoded = jwtDecode(accessToken);
    const currentTime = Date.now() / 1000;
    return decoded.exp > currentTime;
  } catch (error) {
    console.error('Invalid token:', error);
    return false;
  }
};

// Gestion du token en session
const setSession = (token, role) => {
  if (token) {
    // Si token est un objet avec une propriété token (ex: response.data)
    const tokenValue = typeof token === 'object' && token.token ? token.token : token;
    
    window.localStorage.setItem('accessToken', tokenValue);
    if (role) {
      window.localStorage.setItem('role', role);
    }
    axios.defaults.headers.common.Authorization = `Token ${tokenValue}`;
    axios.defaults.headers.post['Content-Type'] = 'application/json';
  } else {
    window.localStorage.removeItem('accessToken');
    window.localStorage.removeItem('role');
    delete axios.defaults.headers.common.Authorization;
  }
};

// Nouvelle fonction pour mettre à jour le token après modification
const updateTokenFromResponse = (response) => {
  if (response.data && response.data.token) {
    const currentRole = window.localStorage.getItem('role');
    setSession(response.data.token, currentRole);
    return true;
  }
  return false;
};

export { isValidToken, setSession, updateTokenFromResponse };